import LoadingSkeleton from 'react-loading-skeleton'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'

function Skeleton() {
  return <>
    <LoadingSkeleton
      baseColor={theme.color.background.neutral.weak}
      highlightColor={theme.color.background.neutral.strong}
      count={6}
      height={72}
      borderRadius={theme.border.radius.default}
      style={{ marginBottom: theme.spacing.km6 }}
      containerTestId='loading-skeleton'
    />
    <LoadingSkeleton
      baseColor={theme.color.background.neutral.weak}
      highlightColor={theme.color.background.neutral.strong}
      height={72}
      borderRadius={theme.border.radius.default}
      style={{ marginBottom: theme.spacing.km6, width: '200px' }}

    />
  </>
}

export default Skeleton
